import { render, staticRenderFns } from "./ContactMe.vue?vue&type=template&id=52572fbe&"
import script from "./ContactMe.vue?vue&type=script&lang=js&"
export * from "./ContactMe.vue?vue&type=script&lang=js&"
import style0 from "./ContactMe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports